import React from 'react';
import { Box } from '@mui/material';

export const InsightsLogoMark = () => (
    <Box
        component="span"
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0,
            height: 32,
            width: 32,
            overflow: 'hidden',
        }}
    >
        <Box
            component="img"
            src="/insights/images/icons/icon-without-background-250x250.png"
            alt=""
            aria-hidden
            sx={{
                display: 'block',
                flexShrink: 0,
                height: 32,
                width: 32,
                maxWidth: 'none',
            }}
        />
    </Box>
);
